import { client } from "../../infrastructure/graphql/client";
import { GET_ALL_INFRASTRUCTURE } from "../../infrastructure/graphql/infrastructureQueries";

export class InfrastructureService {
  async getAllInfrastructure() {
    try {
      const result = await client.query({
        query: GET_ALL_INFRASTRUCTURE,
        fetchPolicy: "no-cache", // Let React Query handle caching, not Apollo
      });

      const response = result.data?.getAllInfrastructure;

      if (!response) {
        return { 
          success: false, 
          message: "No response from server", 
          data: null 
        };
      }

      return {
        success: true,
        data: response,
        vms: response.vms,
        tags: response.tags,
        vmTags: response.vmTags,
      };
    } catch (error) {
      console.error("Get all infrastructure error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { 
        success: false, 
        message: errorMessage, 
        data: null 
      };
    }
  }
}